import { createFileRoute } from '@tanstack/react-router'

import { SearchSchema } from './-utils/search'

export const Route = createFileRoute('/_dashboard/energy-monitoring/')({
  validateSearch: SearchSchema,
})
